<mat-paginator [length]="totalCount"
               [pageSize]="pageSize"
               [pageIndex]="pageIndex"
               (page)="paginate($event)">
</mat-paginator>